<template>
    <v-row>
        <v-col
            cols="12"
            offset="0"
            md="10"
            offset-md="1"
            lg="8" 
            offset-lg="2"
            :xl="data.find(x => x.jahr == selectedYear).content.length > 1 ? 12 : 10"
            offset-xl="0"
            class="d-flex align-center justify-end"
        >
            <div
                class="text-h6"
                style="font-weight: 400;"
            >
                Wähle ein Jahr:
            </div>
            <v-menu
                open-on-hover
                bottom
                offset-y
            >
                <template v-slot:activator="{ attrs, on }">
                    <v-btn
                        v-bind="attrs"
                        class="ml-4 bg-alpha-white"
                        v-on="on"
                    >
                        {{ selectedYear }}
                        <v-icon right>
                            mdi-chevron-down
                        </v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item-group
                        mandatory
                    >
                        <v-list-item
                            v-for="(item, index) in data.map(el => el.jahr).sort((a,b) => b-a)"
                            :key="index"
                            @click="selectedYear = item"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-menu>
        </v-col>
        <!--
        <v-col 
            cols="10"
            offset="1"
            lg="8" 
            offset-lg="2"
        >
            <v-divider class="pb-4 mb-4"></v-divider>
            <galerie :items="data.find(x => x.jahr == selectedYear).images" :rows="getRowCount()" style="display: none;"></galerie>
            <AZCarousel :items="data.find(x => x.jahr == selectedYear).images"></AZCarousel>
        </v-col>
        -->
        <v-col 
            v-for="card in data.find(x => x.jahr == selectedYear).content" 
            :key="card.id"
            cols="12"
            offset="0"
            md="10"
            offset-md="1"
            lg="8" 
            offset-lg="2"
            :xl="data.find(x => x.jahr == selectedYear).content.length > 1 ? 6 : 8"
            :offset-xl="data.find(x => x.jahr == selectedYear).content.length > 1 ? 0 : 2"
        >
            <Card
                :elements="card.content"
                main
                class="pa-4 bg-alpha-white"
                style="height: 100%;"
            />
        </v-col>
    </v-row>
</template>

<script>
import Card from "@/components/Card/Card.vue";

export default {
    components: {
        Card
    },
    props: ["year"],
    data: () => ({

        data: [
            {
                jahr: 2018,
                content: [
                    {
                        id: 1,
                        content: [
                            {
                                type: "title",
                                text: "Aktion Zukunft 2018 Aftermovie"
                            },
                            {
                                type: "video_embedded",
                                aspect_ratio: 0.6525,
                                url: "https://www.youtube.com/embed/tME0JLympEE"
                            }
                        ]
                    },
                    {
                        id: 2,
                        content: [
                            {
                                type: "title",
                                text: "Bildergalerie"
                            },
                            {
                                type: "carousel_card",
                                images: [
                                    require("@/assets/img/impressionen/2018/2018_1.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_2.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_3.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_4.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_5.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_6.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_7.jpg"),
                                    require("@/assets/img/impressionen/2018/2018_8.jpg"),
                                ]
                            }
                        ]
                    },
                ]
            },
            {
                jahr: 2016,
                content: [
                    {
                        id: 1,
                        content: [
                            {
                                type: "title",
                                text: "Bildergalerie"
                            },
                            {
                                type: "carousel_card",
                                images: [
                                    require("@/assets/img/impressionen/2016/seminar (1).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (2).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (3).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (4).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (5).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (6).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (7).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (8).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (9).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (10).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (11).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (12).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (13).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (14).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (15).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (16).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (17).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (18).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (19).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (20).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (21).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (22).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (23).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (24).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (25).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (26).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (27).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (28).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (29).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (30).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (31).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (32).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (33).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (34).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (35).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (36).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (37).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (38).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (39).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (40).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (41).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (42).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (43).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (44).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (45).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (46).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (47).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (48).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (49).jpg"),
                                    require("@/assets/img/impressionen/2016/seminar (50).jpg"),
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        selectedYear: 2018
    }),
    created() {
        if(this.year && this.data.map(el => el.jahr).find(x => x === this.year)) {

            this.selectedYear = this.year;
        }
    },
    methods: {
        getRowCount() {
            let def = 4;

            if(this.$vuetify.breakpoint.smAndDown) {
                def = 2;
            }

            return def;
        }
    }
}
</script>